module.exports = __webpack_public_path__ + "static/media/hired.902e0840.svg";